import React from 'react'

import { Typography } from "@mui/material"


export default function emailColumn() {

	return {
		name: 'email',
		label: 'Email',
		options: {
			filterType: 'textField',
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Typography>{value}</Typography>
		}
	}
}